import { WorkOrderChangeStatusEnum } from 'gql/graphql';

import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useProjectData } from './useProjectData';
import { useSendGpnAnalyticsEvent } from './useSendGpnAnalyticsEvent';

export const useWorkOrderChangeCreate = ({ workOrderId }: { workOrderId: number }) => {
    const { id: projectId } = useParams();
    const { projectData } = useProjectData(projectId, false);

    const { sendGpnAnalyticsEvent } = useSendGpnAnalyticsEvent();

    const [isCreateWorkOrderChangeOpened, setIsCreateWorkOrderChangeOpened] = useState(false);

    const closeCreatingWorkOrderChangeHandler = useCallback(() => {
        setIsCreateWorkOrderChangeOpened(false);
    }, []);
    const openCreatingWorkOrderChangeHandler = useCallback(() => {
        sendGpnAnalyticsEvent({
            componentId: 'rim_create IZM button_pressed',
            projectId,
            contractId: projectData?.contractId,
            orderId: workOrderId,
            orderChangeStatus: WorkOrderChangeStatusEnum.OnFormation,
            projectName: projectData?.name,
            projectType: projectData?.contractType,
            projectDO: projectData?.subsidiary?.name,
            methodology: projectData?.methodology,
        });

        setIsCreateWorkOrderChangeOpened(true);
    }, [
        projectData?.contractId,
        projectData?.contractType,
        projectData?.methodology,
        projectData?.name,
        projectData?.subsidiary?.name,
        projectId,
        sendGpnAnalyticsEvent,
        workOrderId,
    ]);

    return {
        isCreateWorkOrderChangeOpened,
        closeCreatingWorkOrderChangeHandler,
        openCreatingWorkOrderChangeHandler,
    };
};
